/* istanbul ignore file */
import { TextField, FieldProps, useFieldHelper } from 'framework/ui/field';
import { useDateTimeService } from 'framework/utils';
import { Stack, Typography } from '@mui/material';

interface StatusPeriodFieldProps extends FieldProps {
  toSource: string;
}

const StatusPeriodField = ({ toSource, ...props }: StatusPeriodFieldProps) => {
  const { getValue: getFromDate, getLabel } = useFieldHelper(props);
  const { getValue: getToDate } = useFieldHelper({ source: toSource });
  const { formatDateWithFullDateFormat } = useDateTimeService();

  const dateRangeText = `${formatDateWithFullDateFormat(getFromDate())} - ${formatDateWithFullDateFormat(getToDate())}`;

  return (
    <Stack>
      <Typography variant="subtitle1" component="span" mr={0.5} display="inline-block">
        {getLabel() as string}:
      </Typography>
      <TextField {...props} label="" value={dateRangeText} />
    </Stack>
  );
};

export default StatusPeriodField;
